import BaseApiService from '@/services/base-api.service';
import { API_BASE_URL } from '@/config/api';
import { Collection, CollectionsResponse, CollectionCreate, CollectionUpdate } from '../types';

interface CollectionQueryParams {
  skip?: number;
  limit?: number;
}

class CollectionService extends BaseApiService {
  constructor() {
    super(API_BASE_URL);
  }

  async getCollections(params: CollectionQueryParams = {}): Promise<CollectionsResponse> {
    const response = await this.get<CollectionsResponse>('/collections/', { params });
    return response.data;
  }

  async getCollection(id: number): Promise<Collection> {
    const response = await this.get<Collection>(`/collections/${id}`);
    return response.data;
  }

  async createCollection(data: CollectionCreate): Promise<Collection> {
    const response = await this.post<Collection>('/collections/', data);
    return response.data;
  }

  async updateCollection(id: number, data: CollectionUpdate): Promise<Collection> {
    const response = await this.put<Collection>(`/collections/${id}`, data);
    return response.data;
  }

  async deleteCollection(id: number): Promise<void> {
    await this.delete(`/collections/${id}`);
  }

  async addLinkToCollections(linkId: number, collectionIds: number[]): Promise<void> {
    await this.post(`/content/${linkId}/collections/`, { collection_ids: collectionIds });
  }
}

export const collectionService = new CollectionService(); 